<template>
    <v-btn v-if="icon" variant="text" color="on-surface" :icon="'mdi-' + icon" :title="title"
        @click="onclick != undefined ? onclick(context) : undefined">
    </v-btn>
    <v-btn v-else variant="text" color="on-surface" icon="" :title="title"
        @click="onclick != undefined ? onclick(context) : undefined">
        <v-avatar v-if="image" :image="image" :size="32"></v-avatar>
    </v-btn>
</template>

<script>
export default {
    name: 'ToolButton',
    props: {
        title: String,
        icon: String,
        image: String,
        onclick: Function,
        context: Object,
    },
};
</script>

<style scoped>

</style>
